// hooks/useLocalization.js
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const useLocalization = () => {
  const { t, i18n } = useTranslation();

  // ✅ Memoize setLanguage to prevent infinite loops
  const setLanguage = useCallback(
    (languageCode) => {
      if (i18n.language !== languageCode) {
        i18n.changeLanguage(languageCode);
      }
    },
    [i18n]
  );

  // ✅ Memoize getLanguage
  const getLanguage = useCallback(() => {
    return i18n.language;
  }, [i18n.language]);

  return {
    t,
    setLanguage,
    getLanguage,
  };
};

export default useLocalization;
